<div class="body">

    <table mat-table [dataSource]="(providerService.offers$|async)|sortedObjectArray:active:direction:(providerService.offers$|async)?.length" class="table" [matSortActive]="active" [matSortDirection]="direction" matSort (matSortChange)="sortData($event)">

        <ng-container matColumnDef="offernumber">
            <th mat-header-cell mat-sort-header="offernumber" *matHeaderCellDef>Nummer</th>
            <td mat-cell *matCellDef="let element">

                {{element.value.offernumber}}

            </td>
            <td mat-footer-cell *matFooterCellDef [attr.colspan]="6" class="footer">
                {{(providerService.offers$|async)?.length}} Angebot / Angebote
            </td>
        </ng-container>

        <ng-container matColumnDef="offertitle">
            <th mat-header-cell mat-sort-header="offertitle" *matHeaderCellDef>Bezeichnung</th>
            <td mat-cell *matCellDef="let element">

                {{element.value.offertitle}}

            </td>
            <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <ng-container matColumnDef="offerstate">
            <th mat-header-cell mat-sort-header="offerstate" *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let element">

                {{element.value.offerstate|offerStatus|async}}

            </td>
            <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <ng-container matColumnDef="controls">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element" class="control-cell">

                <button mat-icon-button (click)="showOffer(element.value)">
                    <mat-icon>search</mat-icon>
                </button>

            </td>
            <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: columns;" class="body-row"></tr>
        <tr mat-footer-row *matFooterRowDef="footerColumns; sticky: true"></tr>

    </table>

</div>
